// @generated by protoc-gen-connect-web v0.6.0 with parameter "target=ts,ts_nocheck=false"
// @generated from file api/scribe/svc_encounter.proto (package com.diagnocat.scribe, syntax proto3)
/* eslint-disable */

import { ArchiveEncounterReq, ArchiveEncounterResp, CompleteNoteReq, CompleteNoteResp, CreateLiveTranscriptionSessionReq, CreateLiveTranscriptionSessionResp, DeleteEncounterReq, DeleteEncounterResp, ExportPartnerDocumentReq, ExportPartnerDocumentResp, FillProtocolReq, FillProtocolResp, GetDocumentAnswersReq, GetDocumentAnswersResp, GetEncounterReq, GetEncounterResp, GetRecordingCapabilitiesReq, GetRecordingCapabilitiesResp, ListEncountersReq, ListEncountersResp, ListNoteAIStepsReq, ListNoteAIStepsResp, RestoreEncounterReq, RestoreEncounterResp, SetDocumentSectionsReq, SetDocumentSectionsResp, SetDocumentTemplateReq, SetDocumentTemplateResp, UpdateDocumentAnswersReq, UpdateDocumentAnswersResp, UpdateEncounterDocumentReq, UpdateEncounterDocumentResp, UpdateEncounterReq, UpdateEncounterResp } from "./svc_encounter_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service com.diagnocat.scribe.EncounterService
 */
export const EncounterService = {
  typeName: "com.diagnocat.scribe.EncounterService",
  methods: {
    /**
     * Returns authorized recording capabilities for the organization.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterService.GetRecordingCapabilities
     */
    getRecordingCapabilities: {
      name: "GetRecordingCapabilities",
      I: GetRecordingCapabilitiesReq,
      O: GetRecordingCapabilitiesResp,
      kind: MethodKind.Unary,
    },
    /**
     * A deleted encounter answers NotFound unless the caller is an organization
     * API key; so does an archived one unless the caller may view the patient's
     * archive (PatientPermissions.CanViewArchivedEncounters).
     *
     * @generated from rpc com.diagnocat.scribe.EncounterService.Get
     */
    get: {
      name: "Get",
      I: GetEncounterReq,
      O: GetEncounterResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.scribe.EncounterService.List
     */
    list: {
      name: "List",
      I: ListEncountersReq,
      O: ListEncountersResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.scribe.EncounterService.Update
     */
    update: {
      name: "Update",
      I: UpdateEncounterReq,
      O: UpdateEncounterResp,
      kind: MethodKind.Unary,
    },
    /**
     * Requires EncounterPermissions.CanArchive; the encounter must be neither
     * archived nor deleted.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterService.Archive
     */
    archive: {
      name: "Archive",
      I: ArchiveEncounterReq,
      O: ArchiveEncounterResp,
      kind: MethodKind.Unary,
    },
    /**
     * Requires EncounterPermissions.CanRestore; the encounter must be archived
     * and not deleted.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterService.Restore
     */
    restore: {
      name: "Restore",
      I: RestoreEncounterReq,
      O: RestoreEncounterResp,
      kind: MethodKind.Unary,
    },
    /**
     * Requires EncounterPermissions.CanDelete; the encounter must not be
     * deleted. An archived encounter can be deleted.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterService.Delete
     */
    delete: {
      name: "Delete",
      I: DeleteEncounterReq,
      O: DeleteEncounterResp,
      kind: MethodKind.Unary,
    },
    /**
     * Edits section content, approval, or both. Section edits always reset
     * approval, so Approved is ignored when Sections is non-empty.
     * Block notes: Sections edits are refused (the note is edited through
     * UpdateDocumentAnswers), and Approved=true is refused (FailedPrecondition)
     * while the note's View.ReadyToFinish is false.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterService.UpdateDocument
     */
    updateDocument: {
      name: "UpdateDocument",
      I: UpdateEncounterDocumentReq,
      O: UpdateEncounterDocumentResp,
      kind: MethodKind.Unary,
    },
    /**
     * Live treatment mode. Mints a short-lived credential the browser uses to
     * stream audio to the realtime transcription provider.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterService.CreateLiveTranscriptionSession
     */
    createLiveTranscriptionSession: {
      name: "CreateLiveTranscriptionSession",
      I: CreateLiveTranscriptionSessionReq,
      O: CreateLiveTranscriptionSessionResp,
      kind: MethodKind.Unary,
    },
    /**
     * Fills a protocol document's fields from the live transcript so far and
     * returns the accepted answers. Manual answers are never changed. For a
     * block note one call runs up to 3 click rounds while rounds reveal linked
     * lines, and the answers carry their View.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterService.FillProtocol
     */
    fillProtocol: {
      name: "FillProtocol",
      I: FillProtocolReq,
      O: FillProtocolResp,
      kind: MethodKind.Unary,
    },
    /**
     * Block notes: the answers carry their View.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterService.GetDocumentAnswers
     */
    getDocumentAnswers: {
      name: "GetDocumentAnswers",
      I: GetDocumentAnswersReq,
      O: GetDocumentAnswersResp,
      kind: MethodKind.Unary,
    },
    /**
     * Manual edits of structured answers. Block notes also take line, section,
     * added-line and added-block operations; the answers carry their View.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterService.UpdateDocumentAnswers
     */
    updateDocumentAnswers: {
      name: "UpdateDocumentAnswers",
      I: UpdateDocumentAnswersReq,
      O: UpdateDocumentAnswersResp,
      kind: MethodKind.Unary,
    },
    /**
     * Block notes: what the AI steps of one document did, newest first.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterService.ListNoteAISteps
     */
    listNoteAISteps: {
      name: "ListNoteAISteps",
      I: ListNoteAIStepsReq,
      O: ListNoteAIStepsResp,
      kind: MethodKind.Unary,
    },
    /**
     * Partner templates: the note of a document whose template carries a
     * PartnerSource, written back into the partner's template text so it can
     * be pasted into the partner's system. Needs the same access as
     * GetDocumentAnswers; a document whose template has no PartnerSource is
     * refused (FailedPrecondition). Read-only: the answers do not change.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterService.ExportPartnerDocument
     */
    exportPartnerDocument: {
      name: "ExportPartnerDocument",
      I: ExportPartnerDocumentReq,
      O: ExportPartnerDocumentResp,
      kind: MethodKind.Unary,
    },
    /**
     * Block notes: "Complete with AI". Queues a worker job that fills the empty
     * value blocks on the note's shown, open lines: what the transcript says
     * keeps its usual basis, and a block the transcript leaves open may take
     * the value the template offers that best fits the case
     * (NoteAIBasisSuggested, with DocumentAnswer.AIRationale). The clinician's
     * Instructions come first. A manual or AI value is never changed, and a line
     * with no basis stays open. Needs the access of UpdateDocumentAnswers.
     * Refused with FailedPrecondition unless the encounter is completed, the
     * note is not saved to the record (Approved), no completion of the document
     * is queued or running, and Revision is the stored answers revision.
     * The response carries the answers with Completion queued; the client
     * follows GetDocumentAnswers until Completion is finished or failed. Every
     * change of Completion, and every value the job sets, bumps the revision.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterService.CompleteNote
     */
    completeNote: {
      name: "CompleteNote",
      I: CompleteNoteReq,
      O: CompleteNoteResp,
      kind: MethodKind.Unary,
    },
    /**
     * Moves one document of the encounter to another template version (the
     * document's pin), e.g. the clinic version an editor has just saved. Needs
     * access to the encounter and the organization's CanEditSettings, the
     * permission template writes need.
     * TemplateID is a non-deleted version owned by the encounter's
     * organization, of the document's own series or of a series copied from it
     * (a version of that series names a version of the document's series, or
     * the series itself, in DerivedFromID); anything else is InvalidArgument.
     * Refused with FailedPrecondition: an approved document; an encounter in
     * processing or a document being generated; a "Complete with AI" request in
     * progress; a stale BaseRevision; a protocol whose current or target
     * version is not a block template; any other document (summary,
     * evaluation, letter) once it has been generated: re-run that one document
     * with ReprocessEncounter instead (document_template_series_ids and
     * use_latest_templates).
     * A block note is rebased onto the version keeping its AI work (AI values
     * whose block still exists with the same kind and still passes the AI
     * value rule, AI line removals and AI additions whose line or section
     * still exists; correction hints are dropped) and its manual entries by
     * id; the answers revision advances. A completed encounter's note is
     * rendered again from the version. A document not generated yet is
     * generated from the version after Stop.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterService.SetDocumentTemplate
     */
    setDocumentTemplate: {
      name: "SetDocumentTemplate",
      I: SetDocumentTemplateReq,
      O: SetDocumentTemplateResp,
      kind: MethodKind.Unary,
    },
    /**
     * Summary and evaluation: the section titles and AI instructions this
     * encounter's document is generated with, set before the recording ("edit
     * before start"); the clinic's template does not change. Sections names
     * every section of the version the document is pinned to (TemplateID), by
     * its Code, in its order: codes, order and count are the template's. A
     * title is not empty, one row, at most 200 characters and unique ignoring
     * case; an instruction is at most 4000 characters; neither holds a {{…}}
     * placeholder. Refused with InvalidArgument otherwise. An empty Sections,
     * or one equal to the version, clears the override. Needs access to the
     * encounter. Refused with FailedPrecondition: a document of another type;
     * TemplateID that is not the document's pin (re-read the encounter); an
     * approved document; an encounter being processed or a document being
     * generated; a document generated already.
     *
     * @generated from rpc com.diagnocat.scribe.EncounterService.SetDocumentSections
     */
    setDocumentSections: {
      name: "SetDocumentSections",
      I: SetDocumentSectionsReq,
      O: SetDocumentSectionsResp,
      kind: MethodKind.Unary,
    },
  }
} as const;

